import tips from '@/renderer/scripts/utils/tips';
import storage from '@/renderer/scripts/utils/storage/index';
import smh, { SMH } from '@/renderer/scripts/smh';
import { WeakAccessTokenManager } from '@/renderer/scripts/libs/smh-sdk-class';
class CollectAccessTokenManager extends WeakAccessTokenManager<SMH.SpaceToken> {
  //  是否访客
  private visitor: boolean;

  //  验证票据
  private collectUserToken: string;
  constructor(config: SMH.AccessTokenManagerConfig<SMH.SpaceToken>) {
    super(config);
    this.collectUserToken = '';
    this.visitor = true;
  }
  set(collectToken: string, params: any): void {
    const { collectAccessToken, expiresIn, libraryId, spaceId } = params;
    this.tokenMap[collectToken] = {
      libraryId,
      spaceId,
      accessToken: collectAccessToken,
      expiresIn,
      updateTime: new Date().getTime() / 1000,
    };
  }

  /**
   * @description 根据 userToken 从后台换取accessToken 并存入map
   * @private
   * @memberof ShareAccessTokenManager
   * @param collectToken path 路径的参数
   */
  public fetch = async (collectToken: string): Promise<void> => {
    try {
      let res: {
        data: SMH.CollectAccessTokenData;
      };
      // 若有visitor则代表是外部用户
      if (this.visitor) {
        res = await smh.userAPI.getCollectAccessToken({
          collectToken,
          userToken: this.collectUserToken,
        });
      } else {
        res = await smh.userAPI.getCollectAccessTokenInner({
          collectToken,
        });
      }
      this.tokenMap[collectToken] = {
        ...this.tokenMap[collectToken],
        accessToken: res.data.collectAccessToken,
        updateTime: new Date().getTime() / 1000,
        expiresIn: res.data.expiresIn as number,
      };
    } catch (e) {
      tips.error(e as any);
    }
  };

  /**
   * 若内存数据过期，则重新获取新鲜的accessToken
   * 否则直接从内存中获取数据
   * @param collectToken
   */
  async get(collectToken: string): Promise<any> {
    const tokenItem = this.tokenMap[collectToken];
    // 从cookie中拿到解压码，且cookie中存的shareToken与传入的shareToken一致的情况下，方可进行提取
    // 取不到accessToken
    if (!tokenItem && !this.isAccessTokenValid(tokenItem) && this.collectUserToken) {
      await this.fetch(collectToken);
      return {
        ...this.tokenMap[collectToken],
      };
    }
    return {
      ...tokenItem,
    };
  }

  /**
   *
   * @param params
   */
  setData(params: { collectUserToken?: string; visitor?: boolean }): void {
    if ('collectUserToken' in params) {
      this.collectUserToken = params.collectUserToken ?? '';
    }
    if ('visitor' in params) {
      this.visitor = params.visitor ?? true;
    }
  }
}
const collectAccessTokenManager = new CollectAccessTokenManager({
  storage: {
    get: () =>
      new Promise(resolve => {
        const tokenMap = storage.get<Record<string, SMH.SpaceToken>>(storage.StoreKey.COLLECT_ACCESS_TOKEN_MAP);
        resolve(tokenMap);
      }),
    set: (spaceMap: Record<string, SMH.SpaceToken>) => {
      storage.set(storage.StoreKey.COLLECT_ACCESS_TOKEN_MAP, spaceMap);
    },
    del: () => {
      storage.del(storage.StoreKey.COLLECT_ACCESS_TOKEN_MAP);
    },
  },
});

// smh中在初始化的时候，会调用 getShareInfo
smh.initGetInfoFunction({
  /**
   * smh内部的钩子函数，会在下面2个场景时进行调用
   * 1. error的处理中，this.getShareInfo(shareToken, true)
   * 2. getAutoParamsPlugin中 this.getShareInfo(incomingParams.shareToken);
   *
   * @param collectToken
   * @param isFetch
   */
  getCollectInfo: async (collectToken: string, isFetch?: boolean) => {
    if (isFetch) {
      return collectAccessTokenManager.fetch(collectToken);
    }
    return collectAccessTokenManager.get(collectToken);
  },
});
export default collectAccessTokenManager;
